import { InputMaskChangeEvent } from 'primereact/inputmask'

export const onMaskedInputChange = (
  e: InputMaskChangeEvent,
  property: string,
  setObject: (object: any) => void
) => {
  const val = e.target.value
  setObject((prevCamera: any) => ({
    ...prevCamera,
    [property]: val,
  }))
}
